<template>
  <div class="flex flex-col w-full">
    <div
      class="flex flex-row items-center justify-center border-b-4 border-a-primary"
      style="height: 500px"
    >
      <div
        class="flex flex-col w-1/3 items-center justify-center"
      >
        <Icon
          name="ic:outline-contact-support"
          class="text-8xl text-a-secondary"
        />
        <p class="text-4xl font-bold">
          Have any Question or Query?
        </p>
        <p class="text-2xl font-bold">
          Let's talk to our expert team
        </p>
      </div>
      <NuxtImg
        :src="supportTeam"
        class="object-cover h-full w-2/3"
        alt=""
      />
    </div>
    <div
      class="flex flex-row items-start justify-center p-4"
    >
      <div
        class="flex flex-col w-1/2 items-center justify-center"
      >
        <div
          class="flex flex-col w-1/2 rounded-lg shadow-lg hover:shadow-2xl py-4 px-2 items-center justify-center"
        >
          <Icon name="mdi:phone"
            class="text-4xl bg-a-neutral-dim rounded-full p-2 w-min"
          />
          <p
            class="text-3xl font-bold my-1"
          >
            Give us a call
          </p>
          <p
            class="text-2xl font-semibold my-1"
          >
            +1-123-123-1234
          </p>
        </div>
      </div>
      <div
        class="flex flex-col w-1/2 m-4 rounded-md items-center justify-start"
      >
        <p class="text-3xl font-bold">
          Write a query ticket now!
        </p>
        <client-only>
          <ValidationObserver
            tag="form"
            ref="GeneralSupportTicketForm"
            @submit.prevent="
              submitGeneralSupportTicket
            "
            class="flex flex-col items-start justify-start w-1/2"
          >
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="full_name"
                class="text-base font-semibold"
                >Full Name</label
              >
              <BaseTextInput
                v-model="
                  generalSupportTicketForm.full_name
                "
                field-name="full_name"
                validation-label="Full Name"
                validation-rules="required"
              />
            </div>
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="email"
                class="text-base font-semibold"
                >Email</label
              >
              <BaseTextInput
                v-model="
                  generalSupportTicketForm.email
                "
                field-name="email"
                validation-label="Email"
                validation-rules="required|email"
              />
            </div>
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="phone"
                class="text-base font-semibold"
                >Phone</label
              >
              <p
                class="text-xs font-semibold"
              >
                Without +1
              </p>
              <BasePhoneInput
                v-model="
                  generalSupportTicketForm.phone
                "
                field-name="phone"
                validation-label="Phone"
                mask="(###)###-####"
                is-required
              />
            </div>
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="full_name"
                class="text-base font-semibold"
                >Query Type</label
              >
              <BaseSelect
                v-model="
                  generalSupportTicketForm.type
                "
                :options="
                  generalTicketTypes
                "
                field-name="type"
                validation-label="Query Type"
                validation-rules="required"
              />
            </div>
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="subject"
                class="text-base font-semibold"
                >Subject</label
              >
              <BaseTextInput
                v-model="
                  generalSupportTicketForm.subject
                "
                field-name="subject"
                validation-label="Subject"
                has-length-counter
                :max-length-for-counter="
                  150
                "
                validation-rules="required|max:150"
              />
            </div>
            <div
              class="flex flex-col my-0.5 w-full"
            >
              <label
                for="details"
                class="text-base font-semibold"
                >Details</label
              >
              <BaseTextArea
                v-model="
                  generalSupportTicketForm.details
                "
                field-name="details"
                validation-label="Details"
                :rows="8"
                has-length-counter
                :max-length-for-counter="
                  1000
                "
                validation-rules="required|max:1000"
              />
            </div>
            <BaseButton
              width-class="w-full"
              primary-color-class="a-secondary"
              text-color-class="white"
              hovered-background-color-class="a-secondary-dark"
              :loading="
                submitGeneralSupportTicketLoading
              "
              is-submit
              >Submit</BaseButton
            >
          </ValidationObserver>
        </client-only>
      </div>
    </div>
  </div>
</template>
<script setup>
definePageMeta({
  layout: "main-simple",
});

const supportTeam = ref(
  "/images/main/support.jpg"
);
const supportBackground = ref(
  "/images/main/support-bg.svg"
);
const submitGeneralSupportTicketLoading =
  ref(false);
const generalTicketTypes = ref([]);
const generalSupportTicketForm = ref({
  full_name: "",
  email: "",
  phone: "",
  type: "",
  subject: "",
  details: "",
});

async function submitGeneralSupportTicket() {
  // const isValid =
  //   await this.$refs.GeneralSupportTicketForm.validate();
  // if (isValid) {
  //   this.submitGeneralSupportTicketLoading = true;
  //   let createdGeneralSupportTicketResponse =
  //     await this.$baseDataApi.createGeneralSupportTicket(
  //       this
  //         .generalSupportTicketForm
  //     );
  //   if (
  //     !createdGeneralSupportTicketResponse.ok
  //   ) {
  //     this.$store.dispatch(
  //       "BaseAlert/createAlert",
  //       {
  //         text: createdGeneralSupportTicketResponse.statusText,
  //         type: "Error",
  //       }
  //     );
  //   } else {
  //     this.$store.dispatch(
  //       "BaseAlert/createAlert",
  //       {
  //         text: "Successfully submitted query, We will contact you shortly",
  //         type: "Success",
  //       }
  //     );
  //     this.resetGeneralSupportTicketForm();
  //   }
  //   this.submitGeneralSupportTicketLoading = false;
  // }
}

function resetGeneralSupportTicketForm() {
  this.generalSupportTicketForm.full_name =
    "";
  this.generalSupportTicketForm.email =
    "";
  this.generalSupportTicketForm.phone =
    "";
  this.generalSupportTicketForm.type =
    "";
  this.generalSupportTicketForm.subject =
    "";
  this.generalSupportTicketForm.details =
    "";
  this.$refs.GeneralSupportTicketForm.reset();
}

const { data, error } =
  await useAsyncData(() =>
    useNuxtApp().$getGeneralSupportTicketTypes()
  );

if (error.value != null) {
  showError({
    statusMessage: "Something wrong",
  });
} else {
  generalTicketTypes.value = data.value;
}
</script>

<style></style>
